import React from 'react';
import { profile } from '@/actions';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@/state/store';
import { useFormik } from 'formik';
import { TextField, styled } from '@mui/material';
import { Button, Container } from '@/components';
import t from '@/utils/translate';

import { VERIFICATION_CODE_LENGTH } from '@/contracts';

const Form = styled('form')(({ theme }) => ({
  width: theme.spacing(100),
  margin: 'auto',
}));

export default () => {
  const phoneVerificationStarted = useAppSelector((state) => state.authentication.phoneVerificationStarted);

  const formik = useFormik({
    initialValues: { code: '' },
    validate: ({ code }) => {
      const errors: Record<string, string> = {};

      if (!code) {
        errors.code = t('profile.hint.confirmation.code');
      } else if (code.length < VERIFICATION_CODE_LENGTH) {
        errors.code = t('verification.error.codeLength', { length: VERIFICATION_CODE_LENGTH });
      }

      return errors;
    },
    onSubmit: ({ code }) => profile.confirmPhone(code)
  });

  if (!phoneVerificationStarted) {
    return <Navigate to="/profile" replace/>;
  }

  return (
    (
      <>
        <Container margin-h='medium' text-align='center'>
          <h3>{t('verification.hint.code')}</h3>
        </Container>
        <Container text-align='center'>
          <Form onSubmit={formik.handleSubmit}>
            <Container margin-v='small'>
              <TextField
                {...formik.getFieldProps('code')}
                required
                label={t('verification.label.code')}
                error={formik.touched.code && !!formik.errors.code}
                helperText={formik.touched.code && formik.errors.code}
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
                autoFocus
              />
            </Container>
            <Button
              type="submit"
              variant="contained"
              fullWidth
              color="primary"
              size="large"
            >
              {t('verification.action.send')}
            </Button>
          </Form>
        </Container>
      </>
    )
  );
};